const labels = {
  idle: "Aguardando", running: "Em execução", paused: "Pausado",
  completed: "Concluído", available: "Disponível", in_use: "Em uso",
  waiting_pool: "Aguardando pool", cooldown: "Em espera",
  collecting: "Recebendo", offline: "Offline",
  waiting: "Aguardando", error: "Erro",
  waiting_data: "Aguardando dados",
  invalid: "Inválido", expired: "Expirado", discarded: "Descartado",
};

export const StatusBadge = ({ status, testId = "status-badge" }) => (
  <span className={`status-badge status-${status}`} data-testid={testId}>
    <span className="status-dot" />{labels[status] || status}
  </span>
);